<template>  
    <Card> 
        <template slot="title">
            <div class="p-fluid p-grid titulo-card">
                <div class="p-col-12 p-md-8">
                  <h1>Recadastramento</h1>
                </div>                                           
            </div>
        </template>
        <template slot="content">    
            <div class="p-grid p-fluid">
                <div class="p-col botao">
                    <Button label="Pendente" v-if="verificaRoute('CHEFIAGERENCIA_PENDENTE')" class="p-button-raised p-button-rounded"/>
                    <Button label="Pendente" v-else @click="activate('CHEFIAGERENCIA_PENDENTE')" class="p-button-raised p-button-rounded p-button-warning"  icon="pi pi-exclamation-circle" />
                </div>
                <div class="p-col botao">
                    <Button label="Concluído" v-if="verificaRoute('CHEFIAGERENCIA_CONCLUIDO')" class="p-button-raised p-button-rounded"/>
                    <Button label="Concluído" v-else @click="activate('CHEFIAGERENCIA_CONCLUIDO')" class="p-button-raised p-button-rounded p-button-success"  icon="pi pi-check-circle" />
                </div>
                <div class="p-col botao">
                    <Button label="Rejeitados" v-if="verificaRoute('CHEFIAGERENCIA_REJEITADOS')" class="p-button-raised p-button-rounded"/>
                    <Button label="Rejeitados" v-else @click="activate('CHEFIAGERENCIA_REJEITADOS')" class="p-button-raised p-button-rounded p-button-danger"  icon="pi pi-times-circle" />
                </div>
                <router-view />  
            </div>
        </template>     
    </Card>
</template>

<script>
export default {
    name: "gerencia",
    data: function(){        
		return {
            fases:null
		}
    },     
    methods: {
        activate(index) {
            this.$router.push({name: index})
        },
        verificaRoute(nomeEtapa){
            return this.$route.name == nomeEtapa
        }
    }
}
</script>
